<template>
    <IndustryExpertisesAutocomplete
        v-model="state.industryExpertises"
        :placeholder="t('profile.section.industry.expertises.edit.placeholder')"
        :disabled="r$.$value.industryExpertises.length >= industryExpertisesCount.max"
        :errors="r$.$errors.industryExpertises.$self"
        data-testid="profile-industry-expertises"
    />
</template>
<script setup lang="ts">
    import {computed, ref} from 'vue';
    import {maxLength, minLength, withMessage} from '@regle/rules';
    import {storeToRefs} from 'pinia';
    import {useTranslation} from '#imports';
    import {toIndustryExpertiseEditionItem, useScopedRegleItem} from '~/features/about/types/EditAboutSection';
    import IndustryExpertisesAutocomplete from '~/features/industry-expertises/IndustryExpertisesAutocomplete.vue';
    import {useProfileStore} from '~/store/profileStore';
    import {useRulesStore} from '~/store/rules/rulesStore';

    const {t} = useTranslation();
    const {industryExpertisesCount} = storeToRefs(useRulesStore());
    const {industryExpertises} = storeToRefs(useProfileStore());

    const rules = computed(() => ({
        industryExpertises: {
            $each: {},
            minLength: withMessage(
                minLength(industryExpertisesCount.value.min),
                t('profile.section.industry.expertises.edit.min.error', {0: industryExpertisesCount.value.min}),
            ),
            maxLength: withMessage(
                maxLength(industryExpertisesCount.value.max),
                t('profile.section.industry.expertises.edit.max.error', {0: industryExpertisesCount.value.max}),
            ),
        },
    }));
    const defaultState = computed(() => ({
        industryExpertises: industryExpertises.value?.map((item) => toIndustryExpertiseEditionItem(item)) ?? [],
    }));
    const state = ref({...defaultState.value});
    const {r$} = useScopedRegleItem(state, rules, {id: 'industryExpertisesEdition'});
</script>

<style scoped lang="scss">
    .profile-industry-expertises-edition-section {
        &__subtitle {
            font-size: var(--joy-font-size-primary-300);
            color: var(--joy-color-neutral-40);
        }

        &__suggestions {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            gap: var(--joy-core-spacing-3);
        }

        &__suggestion-item {
            cursor: pointer;
        }
    }
</style>
